import React, {useMemo, useEffect, useState} from 'react';

import {isUndefined} from 'lodash'

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';

import {useFormStore} from '../../../Stores/form';

import './index.scss';

export default function BooleanField(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;
    
    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const placeholder = useMemo(() => field.required ? `${field.placeholder} *` : field.placeholder, [field]);

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable))}, [disabled])

    const [value, setValue] = useState("")
    useEffect(() => {
        if (!isUndefined(content[field.id])) {
            setValue(content[field.id] ? "true" : "false");
        }
        else {
            setValue("");
        }
    }, [content[field.id]])

    // console.log(content[field.id])
    // console.log(value)

    const className = useMemo(() => {
        let result = "BooleanField";
        result += showErrorText ? ' error' : ''
        return result;
    }, [showErrorText])

    const onChangeHandler = (e) => {
        onChange({target: {value: e.target.value === "true"}})
    }

    const onChangeBlur = (e) => {
        onBlur({target: {value: content[field.id]}})
    }

    return (<div className={className}>
        <FormControl>
            <FormLabel>{placeholder}:</FormLabel>
            <RadioGroup
                row
                defaultValue=""
                value={value}
                onChange={onChangeHandler}
                onBlur={onChangeBlur}
            >
                <FormControlLabel disabled={isDisabled} value="true" control={<Radio />} label="Так" />
                <FormControlLabel disabled={isDisabled} value="false" control={<Radio />} label="Ні" />
            </RadioGroup>
            {showErrorText && <FormHelperText error={Boolean(showErrorText)}>{showErrorText}</FormHelperText>}
        </FormControl>
    </div>)
}
